export enum SideListOptionType {
    All = 0,
    SharedWithMe = 1,
    CreatedBy = 2,
    Favorite = 3,
    Deleted = 5,
    LastDay = 6,
    LastWeek = 7,
    LastMonth = 8,
    LastQuarter = 9,
    IsNews = 10,
    Draft = 11,
    OnlyNotVisited = 13,
    LateCheckLists = 14,
    CurrentCheckLists = 15,
    NonCurrentChecklists = 16,
    CurrentNotCompleted = 17,
    ForumNewPosts = 18,
    Active = 19,
    Inactive = 20,
    Expired = 21,
    OnlyNotSeen = 23,
    ForumSharedToMe = 24,
    FormsToAnswer = 25,
    AnsweredForms = 26,
    FormsInToDo = 27,
    AllIncludeDeleted = 28, // Documents, MediaBanks
    New = 29, // Documents, MediaBanks,
    OnDemandChecklists = 31, // ChecklistsV2
    OnAuditChecklists = 32, // ChecklistsV2
    RecurringCheckLists = 33, // ChecklistsV2
    OneTimeCheckLists = 34, // ChecklistsV2
    CurrentMobileApp = 35, // ChecklistsV2

    TasksPrivate = 36, // Tasks
    TasksAssignedToMe = 37, // Tasks
    TasksAssignedByMe = 38, // Tasks
    TasksToBeDone = 39, // Tasks

    OnboardingIndependent = 40, // Onboarding
    OnboardingSynchronized = 41, // Onboarding

    WithoutAccessCheck = 100, // Documents, MediaBanks
}
